import { CORE_PLUGIN } from '@/core'
import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'
import 'splitpanes/dist/splitpanes.css'
import {
  container,
  injectable, instanceCachingFactory, registry, singleton
} from 'tsyringe'
import type { App } from 'vue'
import ExpressRate from './view/ExpressRate.vue'
import Bills from './view/FinancialBills.vue'
import FundDetails from './view/FinancialFundDetails.vue'
import Overview from './view/FinancialOverview.vue'

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) =>
      c.resolve(Financial)
    ),
  },
])
@injectable()
export class Financial implements Plugin<unknown, unknown>{
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    // app.component('split-panes', Splitpanes)
    // app.component('split-pane', Pane)
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    plugin.service.addChildRoute({
      path: 'financial/overview',
      component: Overview,
    })
    plugin.service.addChildRoute({
      path: 'financial/bills',
      component: Bills,
    })
    plugin.service.addChildRoute({
      path: 'financial/fund_details',
      component: FundDetails,
    })
    plugin.service.addChildRoute({
      path: 'financial/express_rates',
      component: ExpressRate,
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {
    
  }
}
